import { Capacitor, registerPlugin } from '@capacitor/core';
const InvoicePdf = registerPlugin('InvoicePdf');
export const isAndroidInvoice = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
export const hasNativeInvoicePreview = () => isAndroidInvoice() && Capacitor.isPluginAvailable('InvoicePdf');
async function payload(blob, number) {
  if (!Capacitor.isPluginAvailable('InvoicePdf')) throw new Error('Update the Android app to preview or save invoices.');
  if (blob.size > 20 * 1024 * 1024) throw new Error('Invoice exceeds the 20 MB limit.');
  const base64 = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = () => reject(new Error('Unable to read invoice PDF.'));
    reader.readAsDataURL(blob);
  });
  return { base64, filename: `invoice-${String(number || 'draft').replace(/[^a-z0-9-]+/gi, '_')}.pdf` };
}
export async function previewNativeInvoice(blob, number) { return InvoicePdf.preview(await payload(blob, number)); }
export async function saveNativeInvoice(blob, number) { return InvoicePdf.save(await payload(blob, number)); }
